import { cn } from '@kit/ui/utils';

export function NrfIconInBox({
  icon,
  iconBoxClassName,
}: {
  icon: React.ReactNode;
  iconBoxClassName?: string;
}) {
  return (
    <div
      className={cn(
        'flex h-fit w-fit items-center justify-center rounded-lg bg-primary/20 p-3',
        iconBoxClassName,
      )}
    >
      {icon}
    </div>
  );
}
